import { Star } from "lucide-react";

export const Stars = ({ value = 0, size = 14, onChange, testid }) => (
  <div className="flex items-center gap-0.5" data-testid={testid}>
    {[1, 2, 3, 4, 5].map((n) => (
      <button
        key={n}
        type="button"
        disabled={!onChange}
        onClick={() => onChange?.(n)}
        data-testid={testid ? `${testid}-${n}` : undefined}
        className={onChange ? "cursor-pointer hover:scale-110 transition-transform" : "cursor-default"}
      >
        <Star size={size} strokeWidth={1.5} className={n <= Math.round(value) ? "fill-[#FF9900] text-[#FF9900]" : "text-[#0F0F0F]/30"} />
      </button>
    ))}
  </div>
);

export const RatingSummary = ({ p }) =>
  p.reviews_count > 0 ? (
    <div className="flex items-center gap-2" data-testid={`rating-${p.id}`}>
      <Stars value={p.rating} size={13} />
      <span className="font-mono text-xs text-[#555]">{p.rating} ({p.reviews_count})</span>
    </div>
  ) : null;

export const SavingsTag = ({ p, big }) =>
  p.savings > 0 ? (
    <span
      data-testid={`savings-${p.id}`}
      className={`inline-block bg-[#00A651] text-white font-mono ${big ? "text-sm px-2.5 py-1" : "text-[0.68rem] px-1.5 py-0.5"}`}
    >
      Risparmi {new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(p.savings)}
    </span>
  ) : null;
